class GeneralHelper {
    /**
     * alternative to lodash throttle
     * @param func
     * @param timeFrame
     * @returns {(function(...[*]): void)|*}
     */
    static throttle(func, timeFrame) {
        let lastTime = 0;
        return (...args) => {
            const now = new Date();
            if (now - lastTime >= timeFrame) {
                func(...args);
                lastTime = now;
            }
        };
    }

    static getTargetIdFromUrl(url = window.location.hash) {
        const hashMatch = url.match(/#([^?]*)/);
        return hashMatch ? hashMatch[1] : null;
    }
}

export default GeneralHelper;
